export default __webpack_public_path__ + "static/media/search-close.9235d933.svg";